<template>
  <section>
    <b-tooltip
      :delay="300"
      v-for="(tag, index) in tags.slice(0, sliceIndex)"
      multilined
      :key="index"
      type="is-light"
      size="is-small"
      position="is-right"
      ><template v-slot:content>
        <span style="overflow-wrap: anywhere">{{ tag }}</span>
      </template>

      <span class="pr-2">
        <b-tag ellipsis class="is-light-orange">
          {{ tag }}
        </b-tag>
      </span>
    </b-tooltip>

    <b-tooltip
      v-if="!!tags.slice(sliceIndex).length"
      type="is-light"
      :triggers="['click']"
      :auto-close="['outside', 'escape']"
      multilined
      position="is-bottom"
      size="is-large"
    >
      <template v-slot:content>
        <div class="has-text-centered">
          <b-tooltip
            :delay="300"
            v-for="(tag, index) in tags.slice(sliceIndex)"
            multilined
            :key="index"
            type="is-light"
            size="is-small"
            position="is-left"
            ><template v-slot:content>
              <span style="overflow-wrap: anywhere">{{ tag }}</span>
            </template>

            <span class="pr-2">
              <b-tag ellipsis class="is-light-orange">
                {{ tag }}
              </b-tag>
            </span>
          </b-tooltip>
        </div>
      </template>

      <div class="clickable">
        <b-icon type="is-gray" icon="dots-horizontal"></b-icon>
      </div>
    </b-tooltip>
  </section>
</template>

<script>
export default {
  props: ['tags', 'sliceIndex']
}
</script>
